import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Button from "components/CustomButtons/Button.js";
import Close from "@material-ui/icons/Close";
import classNames from "classnames";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Check from "@material-ui/icons/Check";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import { ErrorMessage, SuccessMessage } from "components/Common/toastify";
import { LoadingMgs } from "components/Common/toastify";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";

import { post } from "../../../lib/requests";

const useStyles = makeStyles(basicsStyle);
const useStyles3 = makeStyles(javascriptStyles);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

const RequestAccessForm = ({
	requestAccessShow,
	setRequestAccessShow,
	messageData,
	setMessageData,
	showMessageDialog,
	setShowMessageDialog,
	requestService,
	setRequestService,
}) => {
	const classes3 = useStyles3();
	const classesBasicsStyle = useStyles();
	const [loading, setLoading] = React.useState(false);
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [userLoggedIn, setUserLoggedIn] = React.useState(null);
	const [checked, setChecked] = React.useState([]);
	const [auscomp_customer, setAuscomp_customer] = React.useState("no");
	const [auscomp_csp_services, setAuscomp_csp_services] = React.useState("no");

	// form validation rules
	const validationSchema = Yup.object().shape({
		name: Yup.string().required("Name is required"),
		business_name: Yup.string().required("Business name is required"),
		email: Yup.string().required("Email is required").email("Email is invalid"),
		phone_number: Yup.string().required("Phone number is required"),
		auscomp_customer: Yup.string(),
		auscomp_csp_services: Yup.string(),
	});
	const formOptions = { resolver: yupResolver(validationSchema) };

	// get functions to build form with useForm() hook
	const {
		register,
		handleSubmit,
		setError,
		setValue,
		reset,
		formState,
	} = useForm(formOptions);
	const { errors } = formState;

	async function onSubmit(formField) {
		setLoading(true);
		LoadingMgs("Request form", "processing...");
		try {
			formField.service = requestService;
			await post("/api/accessrequest", formField)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Request form", "Login success");
						setUserLoggedIn(res.data.records);
						reset();
						setRequestAccessShow(false);
						setChecked([]);
						setAuscomp_customer("no");
						setAuscomp_csp_services("no");
						setMessageData({
							title: "Request form",
							message: res.data.message,
						});
						setShowMessageDialog(true);
					} else {
						ErrorMessage("Request form", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Request form", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Request form", "Something went wrong try again!!");
			setLoading(false);
		}
	}

	const handleToggle = (value) => {
		const currentIndex = checked.indexOf(value);
		const newChecked = [...checked];

		if (currentIndex === -1) {
			newChecked.push(value);
			if (value === 21) {
				setAuscomp_customer("yes");
				setValue("auscomp_customer", "yes");
			}
			if (value === 22) {
				setAuscomp_csp_services("yes");
				setValue("auscomp_csp_services", "yes");
			}
		} else {
			newChecked.splice(currentIndex, 1);
			if (value === 21) {
				setAuscomp_customer("no");
				setValue("auscomp_customer", "no");
			}

			if (value === 22) {
				setAuscomp_csp_services("no");
				setValue("auscomp_csp_services", "no");
			}
		}
		setChecked(newChecked);
	};

	return (
		<Dialog
			classes={{
				root: classes3.modalRoot,
				paper: classes3.modalSmall,
			}}
			open={requestAccessShow}
			TransitionComponent={Transition}
			keepMounted
			onClose={() => setRequestAccessShow(false)}
			aria-labelledby="classic-modal-slide-title"
			aria-describedby="classic-modal-slide-description">
			<DialogTitle
				id="classic-modal-slide-title"
				disableTypography
				className={classNames(classes3.container, classes3.modalHeader)}>
				<Button
					simple
					className={classes3.modalCloseButton}
					key="close"
					aria-label="Close"
					onClick={() => setRequestAccessShow(false)}>
					{" "}
					<Close className={classes3.modalClose} />
				</Button>
				<h4 className={classNames(classes3.modalTitle)}>Request Access Form</h4>
			</DialogTitle>
			<DialogContent
				id="classic-modal-slide-description"
				// className={classes3.modalBody}
			>
				<form
					onSubmit={handleSubmit(onSubmit)}
					id="myForm"
					className={loading ? classNames(classes3.loading) : ""}>
					<GridContainer>
						{/* Name: */}
						<GridItem xs={12} sm={6} md={6}>
							<CustomInput
								id="not-logged-name"
								formControlProps={{
									fullWidth: true,
								}}
								inputProps={{
									placeholder: "Business Name",
									...register("business_name"),
								}}
							/>
							<div className="text-red-600 text-xs ml-3 pt-1">
								{errors.business_name?.message}
							</div>
						</GridItem>

						<GridItem xs={12} sm={6} md={6}>
							<CustomInput
								id="not-logged-name"
								formControlProps={{
									fullWidth: true,
								}}
								inputProps={{
									placeholder: "Your Name",
									...register("name"),
								}}
							/>
							<div className="text-red-600 text-xs ml-3 pt-1">
								{errors.name?.message}
							</div>
						</GridItem>
					</GridContainer>
					<GridContainer>
						{/* Email address: */}
						<GridItem xs={12} sm={6} md={6}>
							<CustomInput
								id="not-logged-email"
								formControlProps={{
									fullWidth: true,
								}}
								inputProps={{
									placeholder: "Your Email address",
									...register("email"),
								}}
							/>
							<div className="text-red-600 text-xs ml-3 pt-1">
								{errors.email?.message}
							</div>
						</GridItem>
						{/* Phone Number: */}
						<GridItem xs={12} sm={6} md={6}>
							<CustomInput
								id="not-logged-number"
								formControlProps={{
									fullWidth: true,
								}}
								inputProps={{
									placeholder: "Your Phone Number",
									...register("phone_number"),
								}}
							/>
							<div className="text-red-600 text-xs ml-3 pt-1">
								{errors.phone_number?.message}
							</div>
						</GridItem>
					</GridContainer>
					<GridContainer>
						{/* Are you already an Auscomp customer?  */}
						<GridItem xs={12} sm={12} md={12}>
							<div
								className={
									classesBasicsStyle.checkboxAndRadio +
									" " +
									classesBasicsStyle.checkboxAndRadioHorizontal
								}>
								<FormControlLabel
									control={
										<Checkbox
											tabIndex={-1}
											onClick={() => handleToggle(21)}
											checkedIcon={<Check className={classesBasicsStyle.checkedIcon} />}
											icon={<Check className={classesBasicsStyle.uncheckedIcon} />}
											classes={{
												checked: classesBasicsStyle.checked,
												root: classesBasicsStyle.checkRoot,
											}}
										/>
									}
									classes={{
										label: classesBasicsStyle.label,
										root: classesBasicsStyle.labelRoot,
									}}
									label="Are you already an Auscomp customer?"
								/>
							</div>
						</GridItem>
						{/* Are you already signed up for Auscomp CSP Services?  */}
						<GridItem xs={12} sm={12} md={12}>
							<div
								className={
									classesBasicsStyle.checkboxAndRadio +
									" " +
									classesBasicsStyle.checkboxAndRadioHorizontal
								}>
								<FormControlLabel
									control={
										<Checkbox
											tabIndex={-1}
											onClick={() => handleToggle(22)}
											checkedIcon={<Check className={classesBasicsStyle.checkedIcon} />}
											icon={<Check className={classesBasicsStyle.uncheckedIcon} />}
											classes={{
												checked: classesBasicsStyle.checked,
												root: classesBasicsStyle.checkRoot,
											}}
										/>
									}
									classes={{
										label: classesBasicsStyle.label,
										root: classesBasicsStyle.labelRoot,
									}}
									label="Are you already signed up for Auscomp CSP Services?"
								/>
								<input
									type="hidden"
									value={auscomp_customer}
									{...register("auscomp_customer")}
								/>
								<input
									type="hidden"
									value={auscomp_csp_services}
									{...register("auscomp_csp_services")}
								/>
							</div>
						</GridItem>
					</GridContainer>
				</form>
			</DialogContent>
			<DialogActions className={classes3.modalFooter}>
				<button
					form="myForm"
					type="submit"
					disabled={formState.isSubmitting}
					className={classesCSStyles?.buttonPrimary}>
					Request Access
				</button>
			</DialogActions>
		</Dialog>
	);
};

export default RequestAccessForm;
